import { Component, Input, Output, EventEmitter } from '@angular/core';

import { BaseModalComponent } from 'shared/modal/_base-modal.component';


@Component({
  moduleId: module.id,
  selector: 'final-modal',
  templateUrl: 'final-modal.component.html',
  styleUrls: ['final-modal.component.scss'],
})
export class FinalModalComponent extends BaseModalComponent {

  @Input() title: string;
  @Input() text: string;
  @Input() leftBtnText: string;
  @Input() rightBtnText: string;

  @Output() leftBtnClick: EventEmitter<any> = new EventEmitter();
  @Output() rightBtnClick: EventEmitter<any> = new EventEmitter();

  /*******************************************
   * COMPONENT HANDLERS
   *******************************************/

  onLeftBtnClick() {
    this.leftBtnClick.emit();
  }

  onRightBtnClick() {
    this.rightBtnClick.emit();
  }

  onHide() {
    this.onHidden.emit();
  }
}
